module.exports = __webpack_public_path__ + "img/north_american_nebula_2_thumb.b8a393a1.png";